var _rect, _path, _path2, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg_(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 530,
    height: 530,
    viewBox: "0 0 530 530",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 530,
    height: 530,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M477.759 286.003C424.723 240.579 375.154 267.076 356.999 286.003H53.2415V469H477.759V286.003Z",
    fill: "#F9F9F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M477.759 286.003C424.723 240.579 375.154 267.076 356.999 286.003H53.2415",
    stroke: "black",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 414.334,
    cy: 323.833,
    r: 29.2163,
    fill: "#D9D9D9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 389.554,
    cy: 323.656,
    r: 9.22621,
    transform: "rotate(45 389.554 323.656)",
    fill: "#1C1B1F"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 438.701,
    cy: 323.656,
    r: 9.22621,
    transform: "rotate(45 438.701 323.656)",
    fill: "#1C1B1F"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 414.157,
    cy: 299.053,
    r: 9.22621,
    transform: "rotate(45 414.157 299.053)",
    fill: "#1C1B1F"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 414.157,
    cy: 348.199,
    r: 9.22621,
    transform: "rotate(45 414.157 348.199)",
    fill: "#1C1B1F"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 106.269,
    cy: 361.324,
    r: 35.2162,
    fill: "#D9D9D9"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 76.4001,
    cy: 361.111,
    r: 11.1209,
    transform: "rotate(45 76.4001 361.111)",
    fill: "#1C1B1F"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 135.64,
    cy: 361.111,
    r: 11.1209,
    transform: "rotate(45 135.64 361.111)",
    fill: "#1C1B1F"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 106.056,
    cy: 331.455,
    r: 11.1209,
    transform: "rotate(45 106.056 331.455)",
    fill: "#1C1B1F"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 106.056,
    cy: 390.694,
    r: 11.1209,
    transform: "rotate(45 106.056 390.694)",
    fill: "#1C1B1F"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 238.265,
    cy: 421.793,
    r: 23.806,
    fill: "#D9D9D9"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 218.074,
    cy: 421.648,
    r: 7.51768,
    transform: "rotate(45 218.074 421.648)",
    fill: "#1C1B1F"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 258.12,
    cy: 421.648,
    r: 7.51768,
    transform: "rotate(45 258.12 421.648)",
    fill: "#1C1B1F"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 238.121,
    cy: 401.601,
    r: 7.51768,
    transform: "rotate(45 238.121 401.601)",
    fill: "#1C1B1F"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 238.121,
    cy: 441.647,
    r: 7.51768,
    transform: "rotate(45 238.121 441.647)",
    fill: "#1C1B1F"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 381.415,
    cy: 410.602,
    r: 17.423,
    fill: "#D9D9D9"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 366.638,
    cy: 410.495,
    r: 5.502,
    transform: "rotate(45 366.638 410.495)",
    fill: "#1C1B1F"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 395.947,
    cy: 410.495,
    r: 5.502,
    transform: "rotate(45 395.947 410.495)",
    fill: "#1C1B1F"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 381.31,
    cy: 395.824,
    r: 5.502,
    transform: "rotate(45 381.31 395.824)",
    fill: "#1C1B1F"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 381.31,
    cy: 425.134,
    r: 5.502,
    transform: "rotate(45 381.31 425.134)",
    fill: "#1C1B1F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M223.411 133.295C214.231 134.663 200.25 133.907 175.632 129.883C160.521 124.406 126.32 122.784 110.396 160.12C104.474 176.793 99.1531 219.85 125.249 258.691C136.514 273.863 158.733 309.723 157.486 331.787C156.287 359.041 161.288 413.903 190.888 415.32C197.081 416.699 210.721 411.515 215.729 379.742C218.161 359.806 227.854 326.036 251.613 320.468C275.959 318.787 295.172 348.202 303.371 366.536C317.519 395.423 332.081 396.358 337.593 393.214C365.46 383.138 354.074 329.239 344.897 303.548C337.204 282.832 347.869 242.016 354.164 224.198C367.656 179.393 349.884 139.815 339.311 125.627C313.093 94.6412 280.888 106.269 268.063 115.956C245.722 127.055 232.586 131.897 223.411 133.295Z",
    stroke: "white",
    strokeWidth: 50,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M223.411 133.295C214.231 134.663 200.25 133.907 175.632 129.883C160.521 124.406 126.32 122.784 110.396 160.12C104.474 176.793 99.1531 219.85 125.249 258.691C136.514 273.863 158.733 309.723 157.486 331.787C156.287 359.041 161.288 413.903 190.888 415.32C197.081 416.699 210.721 411.515 215.729 379.742C218.161 359.806 227.854 326.036 251.613 320.468C275.959 318.787 295.172 348.202 303.371 366.536C317.519 395.423 332.081 396.358 337.593 393.214C365.46 383.138 354.074 329.239 344.897 303.548C337.204 282.832 347.869 242.016 354.164 224.198C367.656 179.393 349.884 139.815 339.311 125.627C313.093 94.6412 280.888 106.269 268.063 115.956C245.722 127.055 232.586 131.897 223.411 133.295Z",
    fill: "#666666"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.891 162.653C111.527 177.983 106.602 218.33 130.943 254.674C136.774 262.545 145.314 275.579 152.291 289.541C159.135 303.235 165.163 319.134 164.444 332.135C163.868 345.325 164.816 365.04 169.351 381.38C171.624 389.573 174.664 396.412 178.454 401.152C182.121 405.738 186.258 408.124 191.221 408.361L191.818 408.39L192.402 408.52C192.675 408.581 195.237 408.835 198.687 405.181C202.176 401.485 206.445 393.8 208.828 378.775C210.116 368.317 213.299 354.141 219.417 341.653C225.482 329.27 235.142 317.173 250.024 313.685L250.572 313.556L251.134 313.518C266.382 312.465 279.178 321.179 288.623 331.225C298.148 341.356 305.368 353.964 309.68 363.578C316.385 377.234 322.729 383.32 327.152 385.824C331.525 388.299 333.898 387.302 334.142 387.163L334.661 386.867L335.224 386.663C339.896 384.974 343.147 381.475 345.299 376.012C347.525 370.366 348.414 362.934 348.172 354.435C347.69 337.485 342.788 318.366 338.35 305.931C333.832 293.719 334.907 276.75 337.412 261.647C339.966 246.249 344.285 231.277 347.538 222.037C360.089 180.135 343.494 143.03 333.851 129.961C322.142 116.211 309.599 112.301 298.796 112.505C287.586 112.717 277.719 117.394 272.262 121.516L271.744 121.907L271.162 122.196C248.782 133.315 234.8 138.607 224.46 140.183L224.448 140.185L224.437 140.187C214.091 141.728 199.171 140.79 174.508 136.76L173.867 136.655L173.257 136.434C166.827 134.103 156.02 132.542 145.246 135.642C134.862 138.63 124.028 146.063 116.891 162.653ZM177.367 123.108C168.655 120.094 155.136 118.297 141.392 122.252C126.959 126.405 112.776 136.782 103.988 157.387L103.903 157.585L103.831 157.788C97.3834 175.941 91.8229 221.434 119.466 262.577L119.558 262.713L119.655 262.845C125.087 270.16 133.231 282.572 139.827 295.77C146.589 309.299 151.042 322.341 150.53 331.395L150.528 331.438L150.526 331.482C149.907 345.545 150.862 366.864 155.924 385.106C158.451 394.212 162.137 403.057 167.571 409.854C173.027 416.677 180.439 421.623 190.013 422.249C195.818 423.279 202.869 421.049 208.819 414.746C214.941 408.261 219.983 397.498 222.611 380.827L222.63 380.707L222.644 380.586C223.799 371.12 226.677 358.506 231.93 347.782C237.149 337.128 244.034 329.646 252.656 327.387C261.561 327.005 270.345 332.126 278.472 340.769C286.651 349.469 293.118 360.675 297.011 369.381L297.061 369.492L297.114 369.601C304.537 384.758 312.527 393.557 320.288 397.95C327.831 402.22 335.227 402.273 340.47 399.578C349.435 396.159 355.06 389.249 358.263 381.121C361.454 373.024 362.369 363.486 362.101 354.039C361.562 335.116 356.193 314.462 351.458 301.205L351.443 301.165L351.428 301.124C348.271 292.622 348.683 278.848 351.158 263.927C353.572 249.371 357.698 235.111 360.733 226.519L360.787 226.365L360.835 226.208C375.127 178.746 356.408 136.911 344.897 121.465L344.769 121.292L344.629 121.127C330.16 104.027 313.549 98.29 298.533 98.574C284.233 98.8444 271.844 104.546 264.407 109.993C242.469 120.864 230.316 125.194 222.372 126.407C214.424 127.588 201.535 127.032 177.367 123.108Z",
    fill: "#1C1B1F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M246.113 124.641C248.459 127.691 247.888 132.065 244.838 134.411C226.822 148.268 212.694 154.899 201.018 158.005C191.316 160.586 183.456 160.641 177.583 160.682C176.436 160.69 175.365 160.697 174.371 160.723C170.524 160.822 167.326 157.784 167.226 153.938C167.127 150.092 170.165 146.893 174.011 146.794C175.283 146.761 176.544 146.749 177.814 146.738C183.614 146.684 189.579 146.63 197.436 144.54C206.934 142.013 219.423 136.38 236.343 123.366C239.393 121.02 243.767 121.591 246.113 124.641Z",
    fill: "#1C1B1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg_);
export default __webpack_public_path__ + "static/media/치과_치주 질환.6adcaaee9afbb8d951959db5702ac22d.svg";
export { ForwardRef as ReactComponent };